import { classNames } from "@/react/helpers/twMergeWithCN";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Benefits } from "./Benefits";
import { Testimonials } from "./Testimonials";

interface PaywallCustomizationProps {
  className?: string;
  shouldHide?: boolean;
}

export const List = ({ shouldHide, className }: PaywallCustomizationProps) => {
  const { paywallCustomization, checkoutPreviewContext } =
    usePaywallCheckoutContext();

  const {
    testimonial_properties: testimonialProperties,
    benefit_properties: benefitProperties,
  } = paywallCustomization || {};

  const areAllPropertiesDisabled =
    !testimonialProperties?.enabled && !benefitProperties?.enabled;

  if (areAllPropertiesDisabled || shouldHide) {
    return null;
  }

  return (
    <div
      className={classNames(
        "grid grid-cols-1 gap-y-9 divide-y *:pt-12",
        className,
        {
          "pb-16 md:pb-0": !!checkoutPreviewContext,
        },
      )}
    >
      <Benefits />
      <Testimonials />
    </div>
  );
};
